import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {
  Form,
  SidebarFormHeader,
  TextfieldElement,
  SelectElement,
   SidebarFormFooter
} from "cw-styleguide-react";

import withAssets from '../../../components/hoc/withAssets';

class VenusManageFilterForm extends Component {

  /**
   * render
   * @returns {JSX.Element}
   */
  render() {

    return (
      <Form theme={['sidebar']} classes={['sidebar--can-collapse']}>
        <SidebarFormHeader heading={this.props.t('styleguide:forms.filterBy')}  searchButtonText={this.props.t('styleguide:forms.applyFilters')} handleSubmit={this.props.handleSubmit} handleReset={this.props.handleReset}/>
        <div className="form__body">
          {/* Venue name */}
          <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.manage.filters.venueName.label')}
                            id={'venueName'}
                            name={'venueName'}
                            value={this.props.values.venueName}
                            onChange={this.props.handleChange}
                            onKeyPress={this.context.preventDefaultOnEnter}/>

          {/* Postcode */}
          <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.manage.filters.postCode.label')}
                            id={'postCode'}
                            name={'postCode'}
                            placeholder={this.props.t('local:view.venues.manage.filters.postCode.placeholder')}
                            value={this.props.values.postCode}
                            onChange={this.props.handleChange}
                            onKeyPress={this.context.preventDefaultOnEnter}/>
          {/* Town/City */}
          <TextfieldElement size={'medium'} label={this.props.t('local:view.venues.manage.filters.townCity.label')}
                         id={'townCity'}
                         name={'townCity'}
                            placeholder={this.props.t('local:view.venues.manage.filters.townCity.placeholder')}
                         value={this.props.values.townCity}
                         onChange={this.props.handleChange}
                            onKeyPress={this.context.preventDefaultOnEnter}
                       />

          {/* Status */}

          <SelectElement size={'medium'} label={this.props.t('local:view.venues.manage.filters.status.label')}
                         id={'status'}
                         name={'status'}
                         value={this.props.values.status}
                         onChange={this.props.handleChange}
                         grouped={true}
                         options={[{
                           value: '',
                           label: this.props.t('styleguide:forms.all')
                         }].concat(this.props.courses.assets.venues.statuses)}
          />
          <SidebarFormFooter handleSubmit={this.props.handleSubmit} handleReset={this.props.handleReset}  searchButtonText={this.props.t('styleguide:forms.applyFilters')}/>
        </div>
      </Form>
    );
  }

}

export default withAssets(withTranslation('local')(VenusManageFilterForm));
